import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { portfolioCompanies, companyLogos } from '../data/mock';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative py-20 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-4 gap-12 mb-16">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img
              src={companyLogos.mainDark}
              alt="Transformative AI Systems"
              className="h-8 mb-6"
            />
            <p className="text-white/40 text-sm leading-relaxed max-w-sm mb-4">
              Systems architecture and engineering for AI-powered operations. We don't sell AI tools—we engineer decision systems.
            </p>
            <p className="text-white/20 text-xs">
              Architecture first. Automation second. AI last.
            </p>
          </div>

          {/* Systems */}
          <div>
            <h4 className="text-xs text-white/30 uppercase tracking-wider mb-6">Systems</h4>
            <ul className="space-y-3">
              {portfolioCompanies.map((company) => (
                <li key={company.id}>
                  <a
                    href={company.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/50 hover:text-white text-sm transition-colors inline-flex items-center gap-1.5"
                  >
                    {company.name}
                    <ArrowUpRight size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs text-white/30 uppercase tracking-wider mb-6">Navigate</h4>
            <ul className="space-y-3">
              {['What We Do', 'Systems', 'Philosophy', 'Capabilities', 'Contact'].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase().replace(' ', '-')}`}
                    className="text-white/50 hover:text-white text-sm transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs">
            © {year} Transformative AI Systems. All rights reserved.
          </p>
          <p className="text-white/20 text-xs">
            Durable systems. Quietly relentless.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
